<template>
	<div class="module-cate">
		<div class="background" >
			<canvas id="homeCanvas" width="100%" height="100%"></canvas>
		</div>
		<div class="login_header" @click="closeCata($event)" id="module_closeCata">
            <p class="login_logo"></p>
            <p class="login_more_logo" @click="controlCata($event)" id="module_controlCata"></p>
        </div>
        <div class="user_cata" v-show="isuser_cata">
            <div class="cata_mask">
                <p class="myrelation" v-mylink="'/index/myrelation'" id="user_cata_myrelation">
                    <i class="re_icon"></i>我的图谱
                </p>
                <p class="outLogin" @click="outLogin()" id="user_cata_outLogin">
                    <i class="out_icon"></i>退出登录
                </p>
            </div>
        </div>
		<div class="module_middle">
			<div class="shape"></div>
			<div class="module_inner">
				<div class="module_left">
					<h1>企业关联关系洞察</br>大数据平台</h1>
					<p class="module_content_comm">基于企业工商大数据，挖掘公开信息中企业的股权投资、高管任职与登记电话、地址关联关系。以某一企业为起点，根据可配置的探查层级与关系类型，逐层向外梳理企业的关系族谱。直观立体的展示企业在工商数据维度中的关联关系，形成客观全貌关联族谱</p>
				</div>
				<div class="module_right">
					<ul>
						<li v-mylink="'/index/overview'" id="all_view"><p>企业全貌族谱查询</p></li>	
						<li v-mylink="'/index/multiquery'" id="multi_view"><p>多节点关联查询</p></li>	
                        <li v-mylink="'/index/contrlWay'" id="contrl_view"><p>企业控制路径</p></li> 
						<li v-mylink="'/index/subrelation'" id="ess_view"><p>企业实质关联族谱</p></li>
						<!-- <li id="risk_view"><p>企业风险关联视图</p></li> -->
                        <li v-mylink="'/index/riskView'" id="risk_view"><p>企业风险关联视图</p></li>	
						<li><p>全局关联族谱视图</p></li>	
						
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
<script >
	export default{
		data() {
			return {
				a:1,
				canvas:"",
				context:"",
				canvasWidth:"",
				canvasHeight:"",
                isuser_cata:false
			}
		},
		mounted(){
			var screenW = $(window).width();
			var screenH = $(window).height();
			var mobileMax = 767;
			var isMobile = function() { return (screenW <= mobileMax)};
			this.canvas = document.getElementById('homeCanvas');
			this.context = this.canvas.getContext('2d');
			this.canvas.width  = screenW;
			this.canvas.height  = screenH;
			if(typeof this.canvasP.renderCanvas != "undefined") this.canvasP.renderCanvas(this.canvas, this.context);

            $("#all_view").on('mouseenter',function(){
                $(".module_content_comm").html("")
                $(".module_content_comm").html("基于企业工商大数据，挖掘公开信息中企业的股权投资、高管任职与登记电话、地址关联关系。以某一企业为起点，根据可配置的探查层级与关系类型，逐层向外梳理企业的关系族谱。直观立体的展示企业在工商数据维度中的关联关系，形成客观全貌关联族谱")
            })
            $("#multi_view").on('mouseenter',function(){
                $(".module_content_comm").html("")
                $(".module_content_comm").html("多节点关联查询产品旨在为客户提供基于股权投资、任职关系与同一电话、同一地址关系系项下，多个企业或自然人间最短关联路径的识别服务。满足快速获取已知多个节点间是否存在关联，以及相关联节点间的关联类型和路径层级的需求")
            })
            $("#contrl_view").on('mouseenter',function(){
                $(".module_content_comm").html("")
                $(".module_content_comm").html("采取穿透制原则，对目标企业的股东与对外投资层层梳理，通过控制力的挖掘算法，对其股东进行追溯并认定最终的实际控制人（机构）。同时向下对目标企业的对外投资进行控制路径的探寻")
            })
            $("#ess_view").on('mouseenter',function(){
                $(".module_content_comm").html("")
                $(".module_content_comm").html("企业实质关联族谱旨在为客户审查企业风险时，从大量繁复的关系网路中，按照官方对关联方认定标准，通过数据挖掘与“控制力”算法的处理，抽离、梳理出其可能构成实际控制或直接重大影响的核心关联族群，在实际业务场景中，满足集团客户核心族群认定或对该企业进行风险判定时，降低甄别与筛选工作")
            })
            $("#risk_view").on('mouseenter',function(){
                $(".module_content_comm").html("")
                $(".module_content_comm").html("企业风险传导具有客观存在性。企业由于外部环境和内部因素的限制，在激烈变化的市场竞争环境下，存在着大量不确定性。只要存在不确定性，企业就面临许多风险。由于经济系统存在直接或间接关联性，导致了风险传导的普遍存在性")
            })
		},
        methods:{
            controlCata:function(event){
                this.isuser_cata = !this.isuser_cata
                event.cancelBubble = true;
            },
            closeCata:function(event){
                this.isuser_cata =false
                event.cancelBubble = true
            },
            outLogin:function(){
                var token = window.localStorage.getItem('token')
                var _this = this
                var _token = {token:token}
                if(!token){
                    _this.$router.push({path:'/login'});
                    return
                }
                var Json_token = JSON.stringify(_token);
                $.ajax({
                    url:_this.api.out_login,
                    data:Json_token,
                    dataType: 'json',
                    contentType: "application/json",
                    type:"delete",
                    success:function(data){
                      if(data.code == 200){
                        window.localStorage.removeItem("token");
                        localStorage.removeItem("usrName");
                        localStorage.removeItem("usrId");
                        _this.$router.push({path:'/login'})
                      }
                }})
            }
        }
	}
</script>

<style lang="scss" scoped type="text/css">
	.module-cate{
		width:100%;
		height:100%;
        min-height:900px;
		display: table;
		background:#010102;   
		background:-webkit-gradient(linear, 0 0, 0 bottom, from(#010102), to(#080636));
		filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=rgb(1,1,2),endcolorstr=rgb(8,6,54),gradientType=0);
		background:-moz-linear-gradient(top, rgb(1,1,2), rgb(8,6,54));
		background:-o-linear-gradient(top, rgb(1,1,2), rgb(8,6,54));
		.background{
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }
        .login_header{
            width:100%;
            height:75px;
            background:rbga(0,0,0,0);
            position:fixed;
            z-index:3;
            top:0;
            left:0;
            .login_logo{
                float:left;
	            width:180px;
	            height:50px;
	            background:url('/static/images/logo.svg') no-repeat;
	            background-size:cover;
	            margin-top:3px;
	            margin-left:20px;
            }
            .login_more_logo{
                float:right;
                width:20px;
                height:16px;
                margin-right:30px;
                margin-top:18px;
                cursor:pointer;
                background:url('/static/images/icon_-more.png');
            }
        }
        .module_middle{
        	position: relative;
        	z-index:2;
        	display:table-cell;
            text-align:center;
            vertical-align:middle;
            .shape{
	        	position:absolute;
	        	width:100px;
	        	height:100px;
	        	bottom:70px;
	        	left:24px;
	        	background:url('/static/images/module_shape.png');
	        	background-position:cover;
	        }
            .module_inner{
            	display:inline-block;
            	width:1630px;
            	height:530px;
            	.module_left{
            		float:left;
            		width:490px;
            		height:580px;
            		margin-right:140px;
            		padding:52px 0 0 48px;
            		text-align:left;
            		h1{
            			font-size:54px;
            			font-family:"Microsoft YaHei";
            			color:#fff;
            			position:relative;
            			margin-bottom:96px;
            			&::before{
            				content:"";
            				width:8px;
            				height:40px;
            				background-color:#fff;
            				position:absolute;
            				top:13px;
            				left:-26px;
            			}
            		}
            		.module_content_comm{
            			font-size:22px;
            			font-family:"Microsoft YaHei";
            			color:#9b9bb8;
            			line-height:42px;
            		}
            		
            	}
            	.module_right{
            		float:left;
            		width:1000px;
            		height:580px;
            		overflow:hidden;
            		ul{
            			width:1040px;
            			height:600px;
            			li{
            				float:left;
            				width:320px;
            				height:280px;
            				margin-right:20px;
            				margin-bottom:20px;
            				text-align:center;
        					display: table;
        					p{
        						font-size:18px;
        						color:rgba(255,255,255,.65);
        						margin-top:232px;
        					}
        					&:hover p{
        						color:#fff;
        					}
        					&:nth-child(1){
        						background:url('/static/images/pic-module1.png');
        					}
        					&:nth-child(1):hover{
        						background:url('/static/images/pic-mouseenter-module1.png');
        						background-position: -36px -32px;
        					}
        					&:nth-child(2){
        						background:url('/static/images/pic-module2.png');
        					}
        					&:nth-child(2):hover{
        						background:url('/static/images/pic-mouseenter-module2.png');
        						background-position: -36px -32px;
        					}
        					&:nth-child(3){
        						background:url('/static/images/pic-module3.png');
        					}
        					&:nth-child(3):hover{
        						background:url('/static/images/pic-mouseenter-module3.png');
        						background-position: -36px -32px;
        					}
        					&:nth-child(4){
        						background:url('/static/images/pic-module4.png');
        					}
        					&:nth-child(4):hover{
        						background:url('/static/images/pic-mouseenter-module4.png');
        						background-position: -36px -32px;
        					}
        					&:nth-child(5){
        						background:url('/static/images/pic-module5.png');
        					}
        					&:nth-child(5):hover{
        						background:url('/static/images/pic-mouseenter-module5.png');
        						background-position: -36px -32px;
        					}
        					&:nth-child(6){
        						background:url('/static/images/pic-module6.png');
        					}
        					&:nth-child(6):hover{
        						background:url('/static/images/pic-mouseenter-module6.png');
        						background-position:-36px -32px;
        					}
        					
            			}
            		}
            	}
            }
        }
	}
    .user_cata{
        position: fixed;
        top:58px;
        right:25px;
        width: 150px;
        height:127px;
        z-index: 3001;
        background: url(/static/images/tips.png) no-repeat;
        .cata_mask{
            height: 110px;
            padding: 4px 14px 0;
            position: relative;
            top:10px;
            left:4px;
            .myrelation{
                height:55px;
                line-height: 55px;
                font-size: 14px;
                color:#666;
                border-bottom: 1px solid #ebeef4;
                cursor: pointer;
            }
            .outLogin{
                height:55px;
                line-height: 55px;
                font-size: 14px;
                color:#666;
                cursor: pointer;
            }
            .re_icon{
                width: 16px;
                height: 18px;
                display: inline-block;
                margin-right: 14px;
                margin-left: 10px;
                position: relative;
                top:4px;
                background: url(/static/images/re_icon.png) no-repeat;
            }
            .out_icon{
                width: 16px;
                height: 16px;
                display: inline-block;
                margin-right: 14px;
                margin-left: 10px;
                position: relative;
                top:4px;
                background: url(/static/images/log_icon.png) no-repeat;
            }
        }
    }
    @media screen and (max-width: 1440px){
        .module-cate{
            width:100%;
            height:100%;
            display: table;
            min-height:600px;
            background:#010102;   
            background:-webkit-gradient(linear, 0 0, 0 bottom, from(#010102), to(#080636));
            filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=rgb(1,1,2),endcolorstr=rgb(8,6,54),gradientType=0);
            background:-moz-linear-gradient(top, rgb(1,1,2), rgb(8,6,54));
            background:-o-linear-gradient(top, rgb(1,1,2), rgb(8,6,54));
            .background{
                position: fixed;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
            }
            .login_header{
                width:100%;
                height:75px;
                background:rbga(0,0,0,0);
                position:fixed;
                z-index:3;
                top:0;
                left:0;
                .login_logo{
                    float:left;
                    width:180px;
                    height:50px;
                    background:url('/static/images/logo.svg') no-repeat;
                    background-size:cover;
                    margin-top:3px;
                    margin-left:20px;
                }
                .login_more_logo{
                    float:right;
                    width:20px;
                    height:16px;
                    margin-right:30px;
                    margin-top:18px;
                    cursor:pointer;
                    background:url('/static/images/icon_-more.png');
                }
            }
            .module_middle{
                position: relative;
                z-index:2;
                display:table-cell;
                text-align:center;
                vertical-align:middle;
                .shape{
                    position:absolute;
                    width:100px*0.7;
                    height:100px*0.7;
                    bottom:100px;
                    left:104px;
                    background:url('/static/images/module_shape.png') no-repeat;
                    background-size:59px 53px;
                    background-position:9px 5px;
                }
                .module_inner{
                    display:inline-block;
                    width:1111px;
                    height:381px;
                    .module_left{
                        float:left;
                        width:490px*0.7;
                        height:580px*0.7;
                        margin-right:140px*0.7;
                        padding:52px*0.7 0 0 48px*0.7;
                        text-align:left;
                        h1{
                            font-size:54px*0.7;
                            font-family:"Microsoft YaHei";
                            color:#fff;
                            position:relative;
                            margin-bottom:96px*0.4;
                            &::before{
                                content:"";
                                width:8px*0.7;
                                height:40px*0.7;
                                background-color:#fff;
                                position:absolute;
                                top:13px*0.7;
                                left:-26px*0.7;
                            }
                        }
                        .module_content_comm{
                            font-size:22px*0.7;
                            font-family:"Microsoft YaHei";
                            color:#9b9bb8;
                            line-height:42px*0.7;
                        }
                        
                    }
                    .module_right{
                        float:left;
                        width:666px;
                        height:580px*0.7;
                        overflow:hidden;
                        ul{
                            width:1040px*0.7;
                            height:600px*0.7;
                            li{
                                float:left;
                                width:320px*0.7;
                                height:280px*0.64;
                                margin-right:20px*0.8;
                                margin-bottom:20px*0.5;
                                text-align:center;
                                display: table;
                                p{
                                    font-size:16px;
                                    color:rgba(255,255,255,.65);
                                    margin-top:232px*0.6;
                                }
                                &:hover p{
                                    color:#fff;
                                }
                                &:nth-child(1){
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-module1.png');
                                    background-position: 0px 0px;
                                    background-size: 206px 182px;
                                }
                                &:nth-child(1):hover{
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-mouseenter-module1.png') no-repeat;
                                    background-position: -20px -21px;
                                    background-size: 259px 239px;
                                }
                                &:nth-child(2){
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-module2.png');
                                    background-position: 0px 0px;
                                    background-size: 206px 182px;
                                }
                                &:nth-child(2):hover{
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-mouseenter-module2.png');
                                    background-position: -20px -21px;
                                    background-size: 259px 239px;
                                }
                                &:nth-child(3){
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-module3.png');
                                    background-position: 0px 0px;
                                    background-size: 206px 182px;
                                }
                                &:nth-child(3):hover{
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-mouseenter-module3.png');
                                    background-position: -20px -21px;
                                    background-size: 259px 239px;
                                }
                                &:nth-child(4){
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-module4.png');
                                    background-position: 0px 0px;
                                    background-size: 206px 182px;
                                }
                                &:nth-child(4):hover{
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-mouseenter-module4.png');
                                    background-position: -20px -21px;
                                    background-size: 259px 239px;
                                }
                                &:nth-child(5){
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-module5.png');
                                    background-position: 0px 0px;
                                    background-size: 206px 182px;
                                }
                                &:nth-child(5):hover{
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-mouseenter-module5.png');
                                    background-position: -20px -21px;
                                    background-size: 259px 239px;
                                }
                                &:nth-child(6){
                                     width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-module6.png');
                                    background-position: 0px 0px;
                                    background-size: 206px 182px;
                                }
                                &:nth-child(6):hover{
                                    width: 211px;
                                    height: 186.2px;
                                    background:url('/static/images/pic-mouseenter-module6.png');
                                    background-position: -20px -21px;
                                    background-size: 259px 239px;
                                }
                                
                            }
                        }
                    }
                }
            }
        }
        .user_cata{
            position: fixed;
            top:58px;
            right:25px;
            width: 150px;
            height:127px;
            z-index: 3001;
            background: url(/static/images/tips.png) no-repeat;
            .cata_mask{
                height: 110px;
                padding: 4px 14px 0;
                position: relative;
                top:10px;
                left:4px;
                .myrelation{
                    height:55px;
                    line-height: 55px;
                    font-size: 14px;
                    color:#666;
                    border-bottom: 1px solid #ebeef4;
                    cursor: pointer;
                }
                .outLogin{
                    height:55px;
                    line-height: 55px;
                    font-size: 14px;
                    color:#666;
                    cursor: pointer;
                }
                .re_icon{
                    width: 16px;
                    height: 18px;
                    display: inline-block;
                    margin-right: 14px;
                    margin-left: 10px;
                    position: relative;
                    top:4px;
                    background: url(/static/images/re_icon.png) no-repeat;
                }
                .out_icon{
                    width: 16px;
                    height: 16px;
                    display: inline-block;
                    margin-right: 14px;
                    margin-left: 10px;
                    position: relative;
                    top:4px;
                    background: url(/static/images/log_icon.png) no-repeat;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// ModuleCate.vue?84cf05a0